export default __webpack_public_path__ + "27550802602ebd6b8201f89a6074579a.png";